// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Rikt","head":"ProcedureTableInfo_head__3LfID"};